__turbopack_context__.v({
  "calloutSection": "PlasmicFeatures-module__JeA83W__calloutSection",
  "contactModal": "PlasmicFeatures-module__JeA83W__contactModal",
  "domEventListener": "PlasmicFeatures-module__JeA83W__domEventListener",
  "featuresMyCme": "PlasmicFeatures-module__JeA83W__featuresMyCme",
  "featuresMyEvaluations": "PlasmicFeatures-module__JeA83W__featuresMyEvaluations",
  "featuresMyGme": "PlasmicFeatures-module__JeA83W__featuresMyGme",
  "featuresNavigation": "PlasmicFeatures-module__JeA83W__featuresNavigation",
  "featuresTopSection": "PlasmicFeatures-module__JeA83W__featuresTopSection",
  "footer": "PlasmicFeatures-module__JeA83W__footer",
  "header": "PlasmicFeatures-module__JeA83W__header",
  "root": "PlasmicFeatures-module__JeA83W__root",
  "serviceMessage": "PlasmicFeatures-module__JeA83W__serviceMessage",
  "serviceMessageWrapper": "PlasmicFeatures-module__JeA83W__serviceMessageWrapper",
});
